module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.$route.name === 'images') ? _c('span', [_vm._v("\n                        Images\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'image') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'images'
      }
    }
  }, [_vm._v("Images")]), _vm._v("\n                        →\n                        " + _vm._s(_vm.getImage(_vm.$route.params.id) ? _vm.getImage(_vm.$route.params.id).name : '') + "\n                    ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'image-create') ? _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'images'
      }
    }
  }, [_vm._v("Images")]), _vm._v("\n                        →\n                        New Image\n                    ")], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d53c54a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Images.vue
// module id = 496
// module chunks = 0